export var DEFAULT_ELEMENT = 'div';
export var DEFAULT_PROP_NAME = 'as';
export var REACT_PROPS_REGEXP = /^((children|dangerouslySetInnerHTML|suppressContentEditableWarning)|(on[A-Z].*)|((data|aria)-.*))$/;